module.exports = "<p></p>\n\n<div *ngIf=\"formLoading\">Loading Form...</div>\n<div id='htmlForm'></div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sterling-form/sterling-form.html
// module id = ./src/app/components/sterling-form/sterling-form.html
// module chunks = main